import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../types';

interface UIState {
  upgradeVisible: boolean;
  wizardDismissed: boolean;
}

const initialState: UIState = {
  upgradeVisible: false,
  wizardDismissed: localStorage.getItem('wizardDismissed') === 'true',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    showUpgradeModal(state) {
      state.upgradeVisible = true;
    },
    hideUpgradeModal(state) {
      state.upgradeVisible = false;
    },
    setWizardDismissed(state) {
      state.wizardDismissed = true;
      localStorage.setItem('wizardDismissed', 'true');
    },
    cancelWizardDismissed(state) {
      state.wizardDismissed = false;
      localStorage.removeItem('wizardDismissed');
    },
  },
});

export const {
  showUpgradeModal,
  hideUpgradeModal,
  setWizardDismissed,
  cancelWizardDismissed,
} = uiSlice.actions;

export const selectIsUpgradeModalVisible = (state: RootState) =>
  state.ui.upgradeVisible;
export const selectWizardDismissed = (state: RootState) =>
  state.ui.wizardDismissed;
export default uiSlice.reducer;
